import {useEffect, useMemo, useState, useContext, useCallback, createContext} from 'react'
import {
    Row,
    Container,
    Card,
    CardBody,
    Col,
    Button,
    CardHeader,
  } from "reactstrap";
import { handleAddEditQuotationApi ,getAllQuotationApi, fetchSingleQuotationApi } from '../../api/quotationApi'
import { getAllActiveCustomersApi } from "../../api/customerApi"
import { getProductRelateDetailsApi, fetchProductRelateSubProductDetailsApi } from "../../api/productApi"
import { useAppSettings } from '../../contexts/AppSettingsContext';
import {handleAddTermsAndConditionApi, getAllTermsAndConditionsApi, handleDeleteTermsAndConditionsApi} from '../../api/termsAndConditionApi'
import { getAllActiveSalesPersonApi } from'../../api/userApi'
import Breadcrumbs from "../../components/common/Breadcrumb";
import { AuthContext } from "../../contexts/AuthContext";
import { pricingPolicyOptions } from "../../utils/constants"
import { calculatePrice } from "../../utils/commenController"
import OpenPopUp from './OpenPopUp';
import { useFormik } from 'formik';
import toast from "react-hot-toast";
import QuoteList from './QuoteList';
import PaginationComponent from "../../components/common/Pagination";
const OpenPopUpWrapper = createContext()
const Index = () => {
  const { appSettings } = useAppSettings();
  const itemsPerPage = process.env.REACT_APP_PAGINATION_ITEMS_PER_PAGE;  

  const { authToken, userDetails } = useContext(AuthContext);
  const [appName, setAppName] = useState('');
  const [appTaxAmount, setAppTaxAmount] = useState('');
  const [appStandardMarkup, setStandardMarkup] = useState('')
  const [modal, setModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [activeCustomers, setActiveCustomers] = useState([])
  const [selectedCustomer, setSelectedCustomer] = useState({})
  const [activeSalesPerson, setActiveSalesPerson] = useState([])
  const [selectedSales, setSelectedSales] = useState({})
  const [sectionItems , setSectionItems] = useState([]) // #Section data
  const [openMainAccordion, setMainAccordionOpen] = useState(null);
  const [openSubAccordion, setSubAccordionOpen] = useState(null);
  const [sectionBaseSavedProducts, setSectionBaseSavedProducts] = useState({})
  const [notSectionBaseSavedProduct, setNotSectionBaseSaveProducts] = useState([]);
  const [termsAndConditions, setTermsAndConditions] = useState([])
  const [appliedDiscount, setAppliedDiscount] =  useState('0');
  const [totalTaxAmount, setTotalTaxAmount] = useState('0');
  const [totalMarkupAmount, setTotalMarkupAmount] = useState('0');
  const [totalFinalAmount , SetTotalFinalAmount] = useState('0')
  const [isSectionActive, setSectionActive] = useState(true);
  const [totalDiscountedPrice, SetTotalDiscountedPrice] = useState('0')
  const [quotations, setQuotations] = useState([])
  const [quotationData, setQuotationData] = useState({}) // Single data
  const [quotationProductData, setQuotationProductData] = useState([]) //Single quotation product data
  const [isEditQuotation, setIsEditQuotation] = useState(false)
  const [isEditQuotationSectionActive, setIsEditQuotationSectionActive] = useState(false)
  const [searchInput, setSearchInput] = useState(null)
  const [isUpdateProductButtonNoSection, setIsUpdateProductButtonNoSection] = useState(true) // HAndling Button color changing 
  const [isUpdateProductButtonSection, setIsUpdateProductButtonSection] = useState({})
  const [selectedProduct, setSelectedProduct] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0);

  useEffect(()=>{
    setAppName(appSettings?.title ||process.env.REACT_APP_APP_NAME);
    setAppTaxAmount(appSettings?.tax_value || 0)
    setStandardMarkup(appSettings?.standard_markup || 0)
  },[appSettings])

console.log("isUpdateProductButtonSection-------------->", isUpdateProductButtonSection);



  // Setting single quote data
  useEffect(()=>{
    if(Object.keys(quotationData).length !==0){
      setSelectedCustomer({label : quotationData.customer.name, value : quotationData.customer.id })
      setSelectedSales({label : quotationData.sales_person?.name, value : quotationData.sales_person?.id })
      setAppliedDiscount(quotationData.discount || 0)
      // setTotalTaxAmount(quotationData.total_markup_amount)
      SetTotalDiscountedPrice(quotationData.total_discount_amount)
      // setTotalMarkupAmount(quotationData.total_markup_amount)
      // SetTotalFinalAmount(quotationData.total_final_amount)
      setSectionActive(quotationData.is_section_active)
      setTermsAndConditions((prev)=>
        prev.map((term)=>
        (
          {
            ...term,
            checked : !!quotationData.terms_and_conditions.find((item)=>item.id == term.id)
          }
      ) 
      )
      )

    } 
  },[quotationData])



  useEffect(()=>{
    fetchAllActiveCustomerData();
    fetchAllActiveSalesPersonData()
  },[authToken])
  useEffect(()=>{
    if(authToken){
      fetchAllQuotation()
    }
  },[authToken, currentPage])
  useEffect(()=>{
    if(!modal){
      fetchAllTermsAndCondition();
    }
  },[authToken, modal])

  // <-------QUOTATION (fetch) -------->
   const fetchAllQuotation = async ()=>{
    try{
      if(!authToken){
        throw new Error("Token not found")
      }
    let response = await getAllQuotationApi(authToken,   currentPage, itemsPerPage);
    const responseData  =  response?.data
    if (response?.code == 200) {
        setQuotations(responseData?.quotations || []);
        setTotalPages(Math.ceil((responseData.totalCount || 1) / itemsPerPage));
    }
    }catch(error){
      console.log(error.message);
    }
   }

   const fetchSingleQuotation = async (id)=>{
    try{
      if(!authToken){
        throw new Error("Token not found")
      }
      const isExcel = false;
      let response = await fetchSingleQuotationApi(authToken, id, isExcel);
      if (response?.code == 200) {
          const responseData = response?.data;

          /* 
          *Initially add  data in to section 
          */
          if (responseData?.is_section_active) {
            
            let formattedDataObj = {};

            const getDistributorInfo = (product) => {
              if (product?.distributors?.length > 0) {
                return {
                  value: product.distributor.id,
                  price: product.distributor.price,
                  markup_price: product.distributor.markup_price,
                  noDistributor: false,
                };
              }
              return {
                value: '',
                label: 'No Distributor',
                gpl_price: product.gpl_price,
                noDistributor: true,
              };
            };
            
            responseData.product_data.forEach((mainSectionItem, sectionIndex) => {
              // Initialize sectionObj directly without sectionIndex inside it
              const sectionObj = {
                sectionName: mainSectionItem.section,
                subSections: {},  // Placeholder for sub-sections
                products: mainSectionItem.products?.map((product) => {
                  const distributor = getDistributorInfo(product);
                  const basePrice = distributor?.gpl_price || distributor?.price;
                  const distributorPriceWithMarkup = calculatePrice(
                    'DISTRIBUTOR_PRICE_WITH_MARKUP',
                    product.pricing_policy,
                    basePrice,
                    product.standard_markup,
                    product.quantity
                  );
                  const markupTotalPrice = calculatePrice(
                    'MARKUP_TOTAL_PRICE',
                    product.pricing_policy,
                    basePrice,
                    product.standard_markup,
                    product.quantity
                  );
            
                  return {
                    manufacture: product.manufacture,
                    distributor,
                    product: {
                      name: product.product_name,
                      value: product.product_id,
                      productCode: product.product_code,
                      label :  product.product_name,
                    },
                    pricing_policy_discount: {
                      type: product.pricing_policy,
                      value: product.discount,
                    },
                    distributor_price_with_markup: distributorPriceWithMarkup,
                    quantity: product.quantity,
                    unit_type: product.unit_type,
                    standard_markup: product.standard_markup,
                    markup_total_price: markupTotalPrice,
                    isChildProductsAvailable: product.isChildProductsAvailable,
                    supportedProducts : product.supporting_products
                  };
                }),
              };
            
              // Process sub-sections (if any)
              mainSectionItem.sub_sections?.forEach((subSection, subSectionIndex) => {
                sectionObj.subSections[subSectionIndex] = subSection.products?.map((product) => {
                  const distributor = getDistributorInfo(product);
                  const basePrice = distributor?.gpl_price || distributor?.price;
                  const distributorPriceWithMarkup = calculatePrice(
                    'DISTRIBUTOR_PRICE_WITH_MARKUP',
                    product.pricing_policy,
                    basePrice,
                    product.standard_markup,
                    product.quantity
                  );
                  const markupTotalPrice = calculatePrice(
                    'MARKUP_TOTAL_PRICE',
                    product.pricing_policy,
                    basePrice,
                    product.standard_markup,
                    product.quantity
                  );
            
                  return {
                    sectionName: subSection.section,
                    manufacture: product.manufacture,
                    distributor,
                    product: {
                      name: product.product_name,
                      value: product.product_id,
                      productCode: product.product_code,
                      label :  product.product_name,
                    },
                    pricing_policy_discount: {
                      type: product.pricing_policy,
                      value: product.discount,
                    },
                    distributor_price_with_markup: distributorPriceWithMarkup,
                    quantity: product.quantity,
                    unit_type: product.unit_type,
                    standard_markup: product.standard_markup,
                    markup_total_price: markupTotalPrice,
                    isChildProductsAvailable: product.isChildProductsAvailable,
                    supportedProducts : product.supporting_products
                  };
                });
              });
            
              // Merge sectionObj into formattedDataObj
              formattedDataObj[sectionIndex] = sectionObj;
            });
            setSectionBaseSavedProducts(formattedDataObj || {});
            setSectionActive(true)
          }else{
              const formattedProductData = responseData.product_data.map((item) => {
                let distributor = {};
      
                if (item?.distributors?.length > 0) {
                  distributor = {
                    value: item.distributor.id,
                    price: item.distributor.price,
                    markup_price: item.distributor.markup_price,
                    noDistributor: false,
                  };
                } else {
                  distributor = {
                    value: '',
                    label: 'No Distributor',
                    gpl_price: item.gpl_price,
                    noDistributor: true,
                  };
                }
    
                const basePrice =  distributor?.gpl_price || distributor?.price
                const distributorPriceWithMarkup =  calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', item.pricing_policy , basePrice,  item.standard_markup, item.quantity) 
                const markupTotalPrice =  calculatePrice('MARKUP_TOTAL_PRICE', item.pricing_policy , basePrice,  item.standard_markup, item.quantity)
                return {
                  manufacture: item.manufacture,
                  distributor: distributor,
                  product: {
                    name: item.product_name,
                    value: item.product_id,
                    productCode: item.product_code,
                  },
                  pricing_policy_discount: {
                    type: item.pricing_policy,
                    value: item.discount,
                  },
                  distributor_price_with_markup: distributorPriceWithMarkup,
                  quantity: item.quantity,
                  unit_type: item.unit_type,
                  standard_markup: item.standard_markup,
                  markup_total_price: markupTotalPrice,
                  isChildProductsAvailable: item.isChildProductsAvailable,
                  supportedProducts : {
                    [item.product_code] :  item.supporting_products || []
                  }
                };
              });

              setNotSectionBaseSaveProducts(formattedProductData || []);
              setSectionActive(false)
            }
            setQuotationData(responseData || {});
            setIsEditQuotation(true)
            setIsEditQuotationSectionActive(responseData?.is_section_active || false)
            setModal(true)
      }
    }catch(error){
      console.log("err", error);
      
    }
   }

   
   const productData =  useMemo(()=>{
          return quotationData.product_data
   },[quotationData])
   useEffect(()=>{
    setQuotationProductData(productData)
   },[productData])

   
  // <-------QUOTATION Fetch End ------------>


  // <-------CUSTOMER (fetch) --------> 
    const fetchAllActiveCustomerData =async ()=>{
      try{
          if(!authToken){
              throw new Error("Token not found")
          }
          let response = await getAllActiveCustomersApi(authToken);
          if (response?.code == 200) {
              setActiveCustomers(response?.data || []);
          }
      }catch(error){
        console.log("err->", error.message);
      }
    }
    const fetchAllActiveSalesPersonData =async ()=>{
      try{
          if(!authToken){
              throw new Error("Token not found")
          }
          let response = await getAllActiveSalesPersonApi(authToken);
          if (response?.code == 200) {
            setActiveSalesPerson(response?.data || []);
          }
      }catch(error){
        console.log("err->", error.message);
      }
    }
    const formattedCustomerData = useMemo(()=>{
      if(!Array.isArray(activeCustomers)){
        return []
      }
      return activeCustomers?.map((item)=>({ label : item.name, value : item.id }))
    },[activeCustomers])

    const formattedSalesPersonData = useMemo(()=>{
      if(!Array.isArray(activeSalesPerson)){
        return []
      }
      return activeSalesPerson?.map((item)=>({ label : item.name, value : item.id }))
    },[activeSalesPerson])
  // <-------CUSTOMER End --------------------> 


  // <-------TERMS AND CONDITION (add, remove, fetch) --------> 
    async function fetchAllTermsAndCondition() {
      try {
        
        if (!authToken) {
          throw new Error("Token not found.");
        }
        let response = await getAllTermsAndConditionsApi(authToken);
        if (response?.code == 200) {
          const data = response?.data || []
          const formattedData =  data.map((item)=>(
            {
              ...item,
              checked : false
            }
          ))
          setTermsAndConditions(formattedData || []);
        }
      } catch (err) {
        console.log("err->", err.message);
      }
    }
    async function handleAddTermsAndCondition(term) {
      try {
        
        if (!authToken) {
          throw new Error("Token not found.");
        }
        let response = await handleAddTermsAndConditionApi(term,authToken);
        if (response?.code == 200) {
            fetchAllTermsAndCondition()
        }
      } catch (err) {
        console.log("err->", err.message);
      }
    }
    async function handleRemoveTermsAndCondition(id) {
      try {
        
        if (!authToken) {
          throw new Error("Token not found.");
        }
        let response = await handleDeleteTermsAndConditionsApi(id,authToken);
        if (response?.code == 200) {
            fetchAllTermsAndCondition()
        }
      } catch (err) {
        console.log("err->", err.message);
      }
    }

  // <-------TERMS AND CONDITION End --------------------> 

  // <---------PRICING POLICY--------------
  const pricingPolicy = useMemo(()=>{
        return pricingPolicyOptions
  },[pricingPolicyOptions])




  const quotationForm = useFormik({
    enableReinitialize : true,
    initialValues : {
      user_id : userDetails?.id,
      crm_ref_no : quotationData?.crm_ref_number || "",
      project_name : quotationData?.subject  || "",
      customer : "",
      // lead_time : quotationData?.lead_time || "",
      saber_fee : quotationData?.saber_fee  || "",
      discount : "",
      terms_and_condition : [],
      quote_validity_period : quotationData?.quote_validity_period || appSettings.quote_validity_period || "",
      quote_delivery_terms : quotationData?.quote_delivery_terms ||  appSettings.quote_delivery_terms || "",
      quote_payment_structure : quotationData?.quote_payment_structure ||  appSettings.quote_payment_structure || "",
      total_tax_amount :  quotationData?.total_tax_amount  || "0",
      total_discount_amount : quotationData?.total_discount_amount  || "0",
      total_markup_amount : quotationData?.total_markup_amount  || "0",
      total_final_amount	: quotationData?.total_final_amount  || "0"
    },
    onSubmit : (values,actions) =>{

      // #Customer
      if(Object.keys(selectedCustomer).length ==0){
          toast.error("Select a customer.")
        return
      }
      if(Object.keys(selectedSales).length ==0){
          toast.error("Select a Salesperson.")
          return
        }
      values.sales_person =  selectedSales.value;
      values.customer =  selectedCustomer.value;

      // #Terms and condition
      values.terms_and_condition = termsAndConditions?.filter((item)=> item.checked == true)?.map((item)=>item.id)

      
      // #Section
      if(isSectionActive){
          values.product_data = filterCheckedSupportedProducts(sectionBaseSavedProducts)
      }else{


    
          let productData =  [...notSectionBaseSavedProduct]
          const filteredCheckedSupportingProducts = productData?.map(item => {
            /* 
             * Attaching supportedProducts
            */
            return {
              ...item, // Keep the other properties intact
              supportedProducts: (item.supportedProducts && item.supportedProducts[item.product.productCode]?.length !==0) 
              ? item.supportedProducts[item.product.productCode]?.filter(product => product.checked === true) : [] // Filter supportedProducts
            };
          })
          values.product_data = filteredCheckedSupportingProducts
          
      }

      values.is_section_active = isSectionActive;
      values.discount = appliedDiscount;
      values.total_discount_amount = totalDiscountedPrice;
      values.total_tax_amount = totalTaxAmount;
      values.total_markup_amount = totalMarkupAmount;
      values.total_final_amount = totalFinalAmount;

      values.isEditQuotation =  false;
      if(isEditQuotation){
         values.isEditQuotation =  true;
         values.id = quotationData?.id;
         values.quote_ref_number = quotationData?.quote_ref_number;
      }
      handleAddOrEditQuotation(values);  

    }
  })


    
  
    const filterCheckedSupportedProducts = (sections) => {

      
      return Object.values(sections)?.map((section, index) => {
        const filteredProducts = section.products?.map(product => ({
          ...product,
          supportedProducts : product.supportedProducts ? product.supportedProducts?.filter(supportedProduct => supportedProduct.checked === true) : []
        }));

        
        // If subSections exist, process them recursively
        const filteredSubSections = section.subSections
          ? Object.values(section.subSections)?.map(subSectionArray => {
              return subSectionArray?.map(subSection => ({
                ...subSection,
                supportedProducts: subSection.supportedProducts ? subSection.supportedProducts?.filter(supportedProduct => supportedProduct.checked === true) : []
              }));
            })
          : {};
    
        return {
          ...section,
          products: filteredProducts,
          subSections: filteredSubSections
        };
      });
    };
  
  // Function handle  add or edit quotation  functionality
  async function handleAddOrEditQuotation(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddEditQuotationApi(values, authToken);
      if (response?.code == 200) {
        setErrorMessage("");
        setSuccessMessage(response.message);
        fetchAllQuotation()
        setModal(false);
        quotationForm.resetForm()
        SetTotalDiscountedPrice("0")
        SetTotalFinalAmount("0")
        setTermsAndConditions([])
        setTotalMarkupAmount('0')
        setCurrentPage(1)
        setNotSectionBaseSaveProducts([])
        setSectionBaseSavedProducts([])
        setSectionItems([])
      } else {
        setSuccessMessage("");
        setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }
  // Function handle open & close modal
  const handleShow = () => {
    setModal((prevState) => !prevState); 
  };
  useEffect(()=>{

    if(!modal){
      quotationForm.resetForm()
      setIsEditQuotation(false);
      setQuotationData({});
      setSelectedCustomer({});
      setErrorMessage("");
      setSuccessMessage("");
      setSearchInput(null)
      setSectionItems([])
      setTermsAndConditions([])
      setSectionBaseSavedProducts({})
      setNotSectionBaseSaveProducts([])
      setQuotationProductData([])
      setIsUpdateProductButtonNoSection(true)
      setIsUpdateProductButtonSection({})
      setSelectedSales({})
    }
  },[modal])

  // <-------------------------------------Product Fetch Start------------------------------->
  // #MAIN SECTION Product loadOptions as an async function
  const loadProductOptions = async (inputValue) => {
      // Only fetch if input has at least 2 characters
      if (inputValue.trim().length <3) {
          return [];
      }

      // Fetch data from the API function
      const activeProductsArr = await fetchProductRelateManufacturesWithDistributors(inputValue);

      
      return activeProductsArr.map((item) => ({
          value: item.name,
          label: item.name,
          productId : item.id,
          productCode : item.product_code,
          data : {
            part_number : item.part_number,
            gpl_price : item?.gpl_price,
            initial_gpl_price : item?.initial_gpl_price,
            manufacturer : item?.manufacturer,
            distributors : item.distributors,
            isCertificateExpired : item.isCertificateExpired,
            isChildProductsAvailable : item.isChildProductsAvailable,
            logistic_fee : item?.logistic_fee,
            custom_fee : item?.custom_fee, 
            logistic_buffer_charge : item.logistic_buffer_charge,
          }

      }));
  }

  // #Fetch Product details
  async function fetchProductRelateManufacturesWithDistributors(searchTerm) {
    try{
      if(!authToken){
        throw new Error('Token not found')
      }
      const isQuotation = true
      let response = await getProductRelateDetailsApi(authToken, searchTerm,isQuotation);
      if (response?.code == 200) {
        return response?.data 
      }
      return []
    }catch(error){
      console.log("message", error.message);
      
    }
  }

  // #Fetch Product relate supporting products
  async function fetchMainProductRelateSupportingProducts(productId) {
    try{
  
      if(!authToken){
        throw new Error('Token not found')
      }
      const isQuotation = true
      let response = await fetchProductRelateSubProductDetailsApi(authToken, productId,isQuotation);
      if (response?.code == 200) {
        return response?.data 
      }
      return []
    }catch(error){
      console.log("message", error.message);
      
    }
  }
  
  // <-------------------------------------Product Fetch End------------------------------->


  const openPopUpPropsObj= {
    modal,
    handleShow,
    successMessage,
    quotationForm,
    selectedCustomer, 
    setSelectedCustomer,
    selectedSales,
    setSelectedSales,
    formattedCustomerData,
    formattedSalesPersonData,
    setSectionItems,
    sectionItems,
    setErrorMessage,
    errorMessage,
    openMainAccordion,
    setMainAccordionOpen,
    openSubAccordion,
    setSubAccordionOpen,
    sectionBaseSavedProducts,
    setSectionBaseSavedProducts,
    handleAddTermsAndCondition,
    handleRemoveTermsAndCondition,
    termsAndConditions,
    setTermsAndConditions,
    loadProductOptions,
    appTaxAmount,
    appStandardMarkup,
    setNotSectionBaseSaveProducts,
    notSectionBaseSavedProduct,
    appliedDiscount, 
    setAppliedDiscount,
    totalTaxAmount, 
    setTotalTaxAmount,
    totalMarkupAmount, 
    setTotalMarkupAmount,
    isSectionActive, 
    setSectionActive,
    totalFinalAmount, 
    SetTotalFinalAmount,
    totalDiscountedPrice, 
    SetTotalDiscountedPrice,
    pricingPolicy,
    isEditQuotation,
    isEditQuotationSectionActive,
    searchInput, 
    setSearchInput,
    quotationProductData, 
    isUpdateProductButtonNoSection, 
    setIsUpdateProductButtonNoSection,
    isUpdateProductButtonSection, 
    setIsUpdateProductButtonSection,
    selectedProduct, setSelectedProduct
  }
  return (
    <div className="page-content">
       <Container fluid={true}>
          <Breadcrumbs title={appName} breadcrumbItem="Quotation" />
          <Row>
            <Col lg={12}>
                <Card>
                    <CardHeader tag="h5" className="p-1 ">
                        <Button color="success" onClick={handleShow}>
                            Add Quotation
                        </Button>
                      <OpenPopUpWrapper.Provider value={{fetchMainProductRelateSupportingProducts, 
                        sectionBaseSavedProducts, 
                        setSectionBaseSavedProducts, 
                        notSectionBaseSavedProduct, 
                        setNotSectionBaseSaveProducts,
                        appStandardMarkup,
                        isSectionActive,
                        pricingPolicy,
                        isEditQuotation,
                        setQuotationProductData,
                        setSectionItems,
                        setIsUpdateProductButtonNoSection,
                        setIsUpdateProductButtonSection,
                        setSelectedProduct
                         }}>
                        <OpenPopUp
                            {...openPopUpPropsObj}
                        />
                      </OpenPopUpWrapper.Provider>

                    </CardHeader>
                    <CardBody >
                    <QuoteList quotations={quotations} fetchSingleQuotation={fetchSingleQuotation}/>
                    </CardBody>
                    <div  className=" d-flex justify-content-end">
                      <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages}/>
                    </div>
                </Card>
            </Col>
          </Row>
       </Container>
       </div>
  )
}

export default Index

export const usePopUpWrapper = () =>useContext(OpenPopUpWrapper)